import React from "react";
import styled from "@emotion/styled";
import { Avatar, Box, Typography} from "@mui/material";
import useAuth from '@/hooks/useAuth';
import { useNavigate } from "react-router-dom";
import LogoComponent from "@/components/logos/Logo";
import SignUp from "../SignUp";

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  const { signIn, signInWithGoogle, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [user, navigate]);

  const loginWithGoogle = async () => {
    try {
      await signInWithGoogle();
      // Redirect handled by useEffect
    } catch (error) {
      setError("Google sign-in failed");
      console.error(error);
    }
  };

  const loginWithEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await signIn(email, password);
      // Redirect handled by useEffect
    } catch (error) {
      setError("Email or password incorrect");
      console.error(error);
    }
  };

  return (
    <div style={{textAlign: 'center', marginBottom: '20px'}}>
      <LogoComponent fill="#0f4c81" style={{width: "100px", margin: "0px auto"}} />
      <br />
      <br />
      <Typography component="h1" variant="h3" align="center" gutterBottom>
        Log in to your account
      </Typography>
      <Box>
        <div style={{textAlign: 'center', marginBottom: '20px'}}>
          <br />
          <SignUp />
          {error && <Typography color="error" style={{ marginTop: 16 }}>{error}</Typography>}
        </div>
      </Box>
    </div>
  );
}

export default SignIn;
